/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TracedCephs/view.blocks to change it.
import CardBase from 'DesignSystem/CardBase/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Info from 'DesignSystem/Info/index'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
let Content = React.lazy(() => import('./Content/index'))



/** @type {import('Simple/types.js').View} */
export default function TracedCephs({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TracedCephs"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="TracedCephs.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z2jD9L2': isBefore ? 0 : 1,'--ty-2-Z2jD9L2': isBefore ? "-8px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TracedCephs.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TracedCephs.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={24}
 text="Traced Cephs"
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={12}
 whiteSpace="wrap"
 hyphens="none"
 fontSize={12}
 lineHeight="16px"
 text="Enable or disable traced cephs features for locations."
/>
</div>
<CardBase
  viewPath={`${viewPath}/CardBase`}
 backgroundColor="#fff"
 shadowColor="rgba(0, 0, 0, 0)"
 flexDirection="column"
 paddingBottom={24}
 zIndex={1000}
 overflowY="visible"
>
{childProps => (
<div
  data-testid="TracedCephs.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
</div>
)}
</CardBase>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</SuspenseBoundary>
</div>
{children}
</React.Fragment>)
}